import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private _accessGrantedForNonMemberFirmUser = false;
  private localStorage;

  constructor() {}

  public get accessGrantedForNonMemberFirmUser() {
    return this._accessGrantedForNonMemberFirmUser;
  }

  public set accessGrantedForNonMemberFirmUser(accessGranted: boolean) {
    this._accessGrantedForNonMemberFirmUser = accessGranted;
  }

  public get localStorageCopy() {
    return this.localStorage;
  }

  public set localStorageCopy(storage) {
    this.localStorage = storage;
  }
}
